const ColumnIcon = ({ color = "black" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8146 2.65589C13.0326 2.44804 13.386 2.44804 13.604 2.65589L15.8365 4.78493C16.0545 4.99279 16.0545 5.32979 15.8365 5.53765C15.6186 5.74551 15.2652 5.74551 15.0472 5.53765L13.7674 4.31724V10.129C13.7674 10.423 13.5176 10.6613 13.2093 10.6613C12.9011 10.6613 12.6512 10.423 12.6512 10.129V4.31724L11.3714 5.53765C11.1534 5.74551 10.8 5.74551 10.5821 5.53765C10.3641 5.32979 10.3641 4.99279 10.5821 4.78493L12.8146 2.65589ZM0 4.45161C0 4.15765 0.249888 3.91935 0.55814 3.91935H3.53488C3.84314 3.91935 4.09302 4.15765 4.09302 4.45161C4.09302 4.74557 3.84314 4.98387 3.53488 4.98387H0.55814C0.249888 4.98387 0 4.74557 0 4.45161ZM0 7.29032C0 6.99636 0.249888 6.75806 0.55814 6.75806H6.51163C6.81988 6.75806 7.06977 6.99636 7.06977 7.29032C7.06977 7.58428 6.81988 7.82258 6.51163 7.82258H0.55814C0.249888 7.82258 0 7.58428 0 7.29032ZM0 10.129C0 9.83507 0.249888 9.59677 0.55814 9.59677H9.48837C9.79662 9.59677 10.0465 9.83507 10.0465 10.129C10.0465 10.423 9.79662 10.6613 9.48837 10.6613H0.55814C0.249888 10.6613 0 10.423 0 10.129ZM0 12.9677C0 12.6738 0.249888 12.4355 0.55814 12.4355H12.4651C12.7734 12.4355 13.0233 12.6738 13.0233 12.9677C13.0233 13.2617 12.7734 13.5 12.4651 13.5H0.55814C0.249888 13.5 0 13.2617 0 12.9677Z"
        fill={color}
      />
    </svg>
  );
};

export default ColumnIcon;
